import React, { useState } from 'react';
import { Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import FileWarehouseForm from './FileWarehouseForm';
import FileSummaryForm from './FileSummaryForm';
import { FilePreviewData } from '../../../services/types';

interface FileFlowProps {
    onClose: () => void;
    onBack: () => void;
}

const SlideLeftTransition = React.forwardRef(function SlideLeftTransition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const FileFlow: React.FC<FileFlowProps> = ({
    onClose,
    onBack,
}) => {
    const [currentStep, setCurrentStep] = useState<'file-upload' | 'summary'>('file-upload');
    const [fileData, setFileData] = useState<{
        file: File;
        previewData: FilePreviewData;
        fileType: 'csv' | 'excel' | null;
    } | null>(null);

    const handleFileUploadComplete = (file: File, previewData: FilePreviewData, fileType: 'csv' | 'excel' | null) => {
        setFileData({ file, previewData, fileType });
        setCurrentStep('summary');
    };

    const handleBackToFileUpload = () => {
        setCurrentStep('file-upload');
        setFileData(null);
    };

    const handleClose = () => {
        setCurrentStep('file-upload');
        setFileData(null);
        onClose();
    };

    return (
        <>
            {/* File Upload Step */}
            <SlideLeftTransition in={currentStep === 'file-upload'} mountOnEnter unmountOnExit>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'white', zIndex: 1000 }}>
                    <FileWarehouseForm
                        onClose={handleClose}
                        onBack={onBack}
                        onNext={handleFileUploadComplete}
                    />
                </div>
            </SlideLeftTransition>

            {/* Summary Step */}
            <SlideLeftTransition in={currentStep === 'summary'} mountOnEnter unmountOnExit>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'white', zIndex: 1000 }}>
                    <FileSummaryForm
                        onClose={handleClose}
                        onBack={handleBackToFileUpload}
                        fileData={fileData}
                    />
                </div>
            </SlideLeftTransition>
        </>
    );
};

export default FileFlow;
